//#region src/payment_terminal_status_recovery_step.ts
var PaymentTerminalStatusRecoveryStep = /* @__PURE__ */ function(PaymentTerminalStatusRecoveryStep) {
	PaymentTerminalStatusRecoveryStep["None"] = "none";
	PaymentTerminalStatusRecoveryStep["Reboot"] = "reboot";
	PaymentTerminalStatusRecoveryStep["IdleText"] = "idle-text";
	return PaymentTerminalStatusRecoveryStep;
}(PaymentTerminalStatusRecoveryStep || {});
//#endregion
export { PaymentTerminalStatusRecoveryStep };

//# sourceMappingURL=payment_terminal_status_recovery_step.js.map